import { Helmet } from "react-helmet-async"
import { RateSheetsList } from "../../../../RateSheets"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"

export default function OrganizationRateSheetsPage() {
	return (
		<>
			<Helmet>
				<title>B2B Rate Sheets | Org</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.VIEW_HOTELS}>
				<RateSheetsList />
			</ForbidUnlessAuthorized>
		</>
	)
}
